// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"64edb0b3","241":"487e328d","383":"23357a38","545":"cc9f8b0e","704":"386089de","722":"628106f4"}[chunkId] + ".chunk.js";
};